/* Edit one glasses bundle; prices and discounts remain Shopify's responsibility. */
(() => {
  'use strict';
  const params = new URLSearchParams(location.search);
  const bundleId = params.get('cart_edit');
  const rxKeys = ['_send_prescription_later', '_copy_prescription', '_sphere_left', '_sphere_right', '_cylinder_left', '_cylinder_right', '_axis_left', '_axis_right', '_add_left', '_add_right', '_pupil_distance', '_pupil_distance_left', '_pupil_distance_right', '_birthdate'];
  const groupOrder = ['glass-purpose', 'progressive-lenses', 'glass-thickness', 'glass-coating', 'extras', 'sunglasses-type'];
  const api = window.GlassifyCartEdit = { requested: !!bundleId, ready: !bundleId, saving: false, original: [], main: null };
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(root() + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Kurven kunne ikke opdateres. Prøv igen.');
    return data;
  }
  const belonging = cart => cart.items.filter(line => String(line.properties?._bundle_instance_id) === bundleId);
  const stable = value => JSON.stringify(Object.keys(value || {}).sort().map(key => [key, String(value[key])]));
  const fingerprint = lines => JSON.stringify(lines.map(line => [String(line.variant_id || line.id), Number(line.quantity), stable(line.properties), line.selling_plan_allocation?.selling_plan?.id || null]).sort((a,b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
  function notice(message, error = false) {
    let box = document.querySelector('.gc-edit-notice');
    if (!box) {
      box = document.createElement('div'); box.className = 'gc-edit-notice'; box.setAttribute('role', 'status');
      const page = document.querySelector('product-page .product-text') || document.querySelector('product-page [data-js-product-title]')?.parentElement || document.querySelector('product-page .product-actions');
      page?.prepend(box);
    }
    box.classList.toggle('gc-edit-error', error);
    box.replaceChildren();
    const strong = document.createElement('strong'); strong.textContent = message; box.append(strong);
    const link = document.createElement('a'); link.href = '#'; link.textContent = 'Tilbage til kurven';
    link.addEventListener('click', event => {
      event.preventDefault();
      document.getElementById('site-cart-sidebar')?.show();
      api.revealInCart();
    }); box.append(link);
  }
  api.showError = message => notice(message, true);
  api.revealInCart = () => {
    const sidebar = document.getElementById('site-cart-sidebar');
    const bundles = [...(sidebar?.querySelectorAll('.gc-bundle[data-bundle-id]') || [])];
    const edited = bundles.find(bundle => bundle.dataset.bundleId === bundleId);
    if (!edited) return;
    bundles.forEach(bundle => {
      const expanded = bundle === edited;
      bundle.classList.toggle('active', expanded);
      bundle.querySelector('.cart-bundle-title')?.setAttribute('aria-expanded', String(expanded));
    });
    // The drawer opens through add-to-cart. Scroll only its body after layout,
    // keeping the page and the fixed payment summary in place.
    requestAnimationFrame(() => {
      const body = sidebar.querySelector('.sidebar__body');
      if (!body || !edited.isConnected) return;
      edited.querySelector('.cart-bundle-title')?.focus({preventScroll:true});
      body.scrollTo({top: body.scrollTop + edited.getBoundingClientRect().top - body.getBoundingClientRect().top - 12, behavior:'instant'});
    });
  };
  function labelButtons() {
    document.querySelectorAll('[data-js-product-add-to-cart-text]').forEach(label => {label.textContent = 'Gem ændringer i kurven';});
  }
  function choose(input) {
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', {bubbles: true}));
  }
  function nestedVariant(id) {
    const input = [...document.querySelectorAll('.sunglasses-type-input input, .transition-input-list input')].find(el => el.id === String(id));
    if (!input) return false;
    if (input.closest('.transition-input-list')) {
      choose(document.getElementById('extras-four')); choose(input); return true;
    }
    choose(document.getElementById('extras-three'));
    const type = input.closest('.sunglasses-type-input')?.getAttribute('input-type');
    choose([...document.querySelectorAll('input[name="sunglasses-type"]')].find(el => el.getAttribute('input-type') === type));
    choose(input); return true;
  }
  function restoreChoices(lines, main) {
    let configuration = [];
    try { configuration = JSON.parse(main.properties._glassify_configuration || '[]'); } catch (_) { /* Legacy cart: use variant IDs below. */ }
    // Parent selections first; nested color choices update the parent's variant ID.
    groupOrder.forEach(name => {
      const saved = configuration.find(entry => entry.name === name);
      if (saved) choose(document.getElementById(saved.id));
    });
    const extraLines = lines.filter(line => line !== main);
    extraLines.forEach(line => {
      const id = String(line.variant_id);
      const input = [...document.querySelectorAll('[data-extra-variant-id]')].find(el => el.getAttribute('variant-id') === id);
      if (input) choose(input);
      else nestedVariant(id);
    });
    // A color is authoritative even when a parent's saved/default variant also matches.
    extraLines.forEach(line => { nestedVariant(line.variant_id); });
    const selectedIds = [...document.querySelectorAll('[data-extra-variant-id]:checked')].map(el => el.getAttribute('variant-id'));
    const expectedIds = extraLines.map(line => String(line.variant_id));
    if (expectedIds.some(id => !selectedIds.includes(id)) || selectedIds.some(id => !expectedIds.includes(id))) {
      throw new Error('Et af dine tidligere glasvalg findes ikke længere på denne side. Kurven er bevaret. Kontakt os, så hjælper vi med ændringen.');
    }
  }
  async function restorePrescription(main) {
    const properties = main.properties || {};
    const hasManual = properties._sphere_left !== undefined || properties._sphere_right !== undefined;
    const hasUpload = Object.entries(properties).some(([key,value]) => /file|upload|recept|prescription/i.test(key) && /^https?:/.test(String(value)));
    const method = properties._prescription_method !== undefined ? Number(properties._prescription_method) : hasManual ? 1 : hasUpload ? 2 : properties._send_prescription_later ? 0 : document.getElementById('send_glasses_data_copy_prescription') ? 3 : 0;
    const ids = ['send_glasses_data_later', 'send_glasses_data_enter_manually', 'send_glasses_data_upload_photo', 'send_glasses_data_copy_prescription'];
    const methodInput = document.getElementById(ids[method]);
    if (!methodInput) return;
    choose(methodInput);
    if (method === 1) {
      const splitPD = document.getElementById('left-and-right-prescription-values');
      if (splitPD) {splitPD.checked = properties._pupil_distance_left !== undefined; splitPD.dispatchEvent(new Event('change', {bubbles:true}));}
      for (const key of rxKeys) {
        if (properties[key] === undefined) continue;
        const box = document.getElementById(key);
        if (!box?.classList.contains('selectBox')) continue;
        const option = [...box.querySelectorAll('.selectOption')].find(el => el.getAttribute('value') === String(properties[key]));
        if (!option) throw new Error('En gemt styrke kan ikke vælges på siden. Kurven er bevaret. Kontakt os for hjælp.');
        option.click(); box.classList.remove('open');
      }
      // Existing prescription listeners update their hidden fields in the next task.
      await new Promise(resolve => setTimeout(resolve, 0));
      rxKeys.forEach(key => {const input = document.querySelector(`input[name="properties[${key}]"]`); if (input && properties[key] !== undefined) input.value = properties[key];});
      window.single_vison.ready_to_add_to_cart = true;
    } else if (method === 2) {
      const container = document.querySelector('#uploadery-container') || document.querySelector('#uploadery');
      if (container) {
        const saved = document.createElement('p'); saved.className = 'gc-saved-upload'; saved.textContent = 'Din tidligere upload er gemt. Upload kun et nyt billede, hvis den skal erstattes.'; container.prepend(saved);
        Object.entries(properties).forEach(([key,value]) => {
          if (!/^https?:/.test(String(value)) || !/file|upload|recept|prescription/i.test(key)) return;
          const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; input.value = value; input.dataset.gcSavedUpload = 'true'; container.append(input);
        });
        window.single_vison.ready_to_add_to_cart = true;
      }
    }
  }
  api.decorate = payload => {
    const main = payload.items.find(line => line.properties?._is_main_product && !line.properties?._subscription_product_type);
    if (!main) return payload;
    const selected = [...document.querySelectorAll('product-page input[type="radio"]:checked')].filter(el => groupOrder.includes(el.name)).map(el => ({id:el.id, name:el.name}));
    main.properties._glassify_configuration = JSON.stringify(selected);
    main.properties._prescription_method = window.single_vison?.prescription_values_method ?? 0;
    if (Number(main.properties._prescription_method) === 3) main.properties._copy_prescription = true;
    if (api.requested && api.main) {
      const preserved = {...api.main.properties};
      rxKeys.forEach(key => delete preserved[key]);
      if (Number(main.properties._prescription_method) !== 2) Object.keys(preserved).forEach(key => {if (/file|upload/i.test(key)) delete preserved[key];});
      main.properties = {...preserved, ...main.properties, _bundle_instance_id:bundleId};
      payload.items = payload.items.filter(line => !line.properties?._subscription_product_type);
      payload.items.forEach(line => {line.quantity = api.original.find(old => String(old.variant_id) === String(line.id))?.quantity || api.main.quantity; line.properties._bundle_instance_id = bundleId;});
    }
    return payload;
  };
  api.commit = async payload => {
    if (!api.ready || api.saving) throw new Error('Vent, mens dine valg indlæses.');
    api.saving = true;
    const revision = Date.now().toString(36) + Math.random().toString(36).slice(2,9);
    let added;
    try {
      const before = await request('cart.js');
      if (fingerprint(belonging(before)) !== fingerprint(api.original)) throw new Error('Denne brille er ændret i kurven imens. Åbn den igen fra kurven, før du gemmer.');
      payload.items.forEach(line => {line.properties._edit_revision = revision;});
      try {
        added = await request('cart/add.js', payload);
        const afterAdd = await request('cart.js');
        const oldLines = belonging(afterAdd).filter(line => line.properties._edit_revision !== revision);
        const newLines = belonging(afterAdd).filter(line => line.properties._edit_revision === revision);
        if (fingerprint(oldLines) !== fingerprint(api.original) || newLines.length !== payload.items.length) throw new Error('Kurven blev ændret under gemningen. Prøv igen fra kurven.');
        const updates = Object.fromEntries(oldLines.map(line => [line.key, 0]));
        await request('cart/update.js', {updates});
      } catch (error) {
        const recovery = await request('cart.js');
        const oldLines = belonging(recovery).filter(line => line.properties._edit_revision !== revision);
        const newLines = belonging(recovery).filter(line => line.properties._edit_revision === revision);
        // A response may be lost after Shopify completed the replacement.
        if (oldLines.length === 0 && newLines.length === payload.items.length) {
          added = {items:newLines};
        } else {
          if (newLines.length) await request('cart/update.js', {updates:Object.fromEntries(newLines.map(line => [line.key,0]))});
          throw error;
        }
      }
      const verified = await request('cart.js');
      api.original = belonging(verified);
      api.main = api.original.find(line => line.properties?._is_main_product === 'true' || line.properties?._is_main_product === true);
      if (!api.main || api.original.some(line => line.properties._edit_revision !== revision)) throw new Error('Gemningen kunne ikke bekræftes. Kontrollér kurven, før du prøver igen.');
      notice('Dine ændringer er gemt i kurven.');
      return {ok:true, json:async()=>added};
    } finally {api.saving = false;}
  };
  async function init() {
    if (params.get('cart_open') === '1') {
      document.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]')?.click();
    }
    if (!bundleId || !document.querySelector('product-page')) return;
    document.documentElement.classList.add('gc-edit-mode');
    labelButtons(); notice('Indlæser brillen fra din kurv …');
    document.addEventListener('submit', event => {
      if (event.target.closest('product-form[data-pdp-form]') && (!api.ready || api.saving)) {event.preventDefault(); event.stopImmediatePropagation();}
    }, true);
    try {
      const cart = await request('cart.js');
      api.original = belonging(cart);
      api.main = api.original.find(line => line.properties?._is_main_product === 'true' || line.properties?._is_main_product === true);
      if (!api.main) throw new Error('Brillen findes ikke længere i kurven.');
      const productId = document.querySelector('product-form[data-pdp-form] input[name="product-id"]')?.value;
      if (productId && String(api.main.product_id) !== productId) throw new Error('Åbn den rigtige produktside med Rediger fra kurven.');
      restoreChoices(api.original, api.main);
      await restorePrescription(api.main);
      document.querySelectorAll('product-form[data-pdp-form] input[name="id"]').forEach(input => {input.value = api.main.variant_id;});
      document.querySelectorAll('product-page .subscription-input').forEach(input => {input.checked = false;});
      window.logTotalPrices?.();
      api.ready = true;
      notice('Du redigerer ' + api.main.product_title + '. Dine øvrige briller bliver i kurven.');
      labelButtons();
      document.addEventListener('VARIANT_CHANGE', labelButtons);
    } catch (error) {notice(error.message, true);}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
